<template>
  <edit-modal
    :caption="caption"
    :wide="step > 0"
    :isActive="isActive">

    <template>
      <import-from-file
        @importfromfile:changed="set">
      </import-from-file>
    </template>

    <hr>

    <save-buttons
      @save="submit"
      @cancel="cancel"
      saveCaption="Opslaan">
    </save-buttons>
  </edit-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import EditModal from '../modules/EditModal'
import ImportFromFile from './ImportFromFile'
import SaveButtons from '../modules/SaveButtons'

export default {
  name: 'ImportValues',
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  components: {
    EditModal,
    SaveButtons,
    ImportFromFile,
  },
  data () {
    return {
      from: null,
      step: 0,
      rows: {
        to: null,
        from: 1
      },
      mapping: [],
    }
  },
  computed: {
    ...mapGetters({
      columns: 'columns/columns',
    }),
    caption () {
      return 'Basislijstwaardes importeren uit Excel-bestand'
    },
    params () {
      return {
        to: this.$route.params.bundleId,
        from: this.from,
        rows: this.rows,
        mapping: this.mapping.map((column, index) => {
          if (column) {
            return {
              columnIdx: index,
              columnId: column
            }
          }
        }).filter(column => column)
      }
    }
  },
  methods: {
    set (payload) {
      this[payload.key] = payload.value
    },
    reset () {
      this.from = null,
      this.step = 0
      this.rows = {
        to: null,
        from: 1
      }
      this.mapping = []
    },
    submit () {
      this.$store.dispatch('values/importValues', this.params)

      this.reset()
      this.$emit('close')
      this.$store.commit('files/UNSET_FILE')
    },
    cancel () {
      if (this.from) this.$store.dispatch('files/destroy', this.from.replace('uploads/', ''))

      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
